import { render, staticRenderFns } from "./TailwindButton.vue?vue&type=template&id=0689d9c0&"
import script from "./TailwindButton.vue?vue&type=script&lang=js&"
export * from "./TailwindButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports